import React from 'react';
import { Checkbox } from '@material-ui/core';
const defaultOptions = { checked: false };
export default (options = defaultOptions) => class extends React.Component {
    componentDidMount() {
        if (!this.props.value && this.props.value !== false) {
            this.props.setValue(Boolean(options.checked));
        }
    }
    render() {
        const { value, setValue } = this.props;
        return (React.createElement(Checkbox, { checked: value || options.checked, onChange: (e, checked) => {
                return setValue(checked);
            } }));
    }
};
